import {store} from "../App";
import {getFromHub} from "./networkActions";

export function setItinerary(itineraryEntries) {
    const itinerary = itineraryEntries.map(itineraryEntry => {
        itineraryEntry.expanded = false;
        itineraryEntry.scrollTo = false;
        return itineraryEntry;
    });

    store.dispatch({type: "SET_ITINERARY", itinerary});
}

export function updateItinerary() {
    getFromHub('prebooking/cruises/itinerary', setItinerary);
}

export function expandAll() {
    store.dispatch({type: "ITINERARY_TOGGLE_ALL", open: true});
}

export function collapseAll() {
    store.dispatch({type: "ITINERARY_TOGGLE_ALL", open: false});
}

export function toggleExpand(itineraryId, open = null) {
    store.dispatch({type: "ITINERARY_TOGGLE_ONE", itineraryId, open});
}

export function setScrollToItineraryEntry(itineraryKey) {
    if(itineraryKey && itineraryKey.length > 10) {
        store.dispatch({type: "ITINERARY_SET_SCROLL_TO", itineraryId: itineraryKey});
    }
    else {
        store.dispatch({type: "ITINERARY_SET_SCROLL_TO", itineraryDate: itineraryKey});
    }

}
